/*
	ESASignClient集成使用js
	版本：1.1
	功能列表：
	1.安全身份认证
	2.WEB签章
	3.PDF签章
 */
/*通用链接云中间件接口函数*/
import  Base64 from "./jquery.base64";

function esaLinkServer(commond, code, params, fuc, retparam, ishttps)
{
	var inputdata = {"command" : commond,"code" : code,"parameter" : params};
	var data = JSON.stringify(inputdata);
	data = Base64.Base64.encode(data);
	var urldata;
	/*
	if (ishttps)
	{
		urldata = "https://127.0.0.1:1991?data=";
	}else{
		urldata = "http://127.0.0.1:1990?data=";
	}
	*/
	if (ishttps)
	{
		urldata = "https://127.0.0.1:18666?data=";
	}else{
		urldata = "http://127.0.0.1:16888?data=";
	}
	urldata = urldata + data;
	var ajax = $.ajax({
		type : "get",
		async : false,
		url : urldata,
		dataType : "jsonp",
		jsonp : "callback",//传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(默认为:callback)
		jsonpCallback : "success_jsonpCallback",//自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名
		success : function(json){
			fuc(json.error,json["msg"],json["parameter"],retparam);
		}
	});
}

/*通用返回处理接口*/
function retfunc(status,msg,retpar,params)
{
	if (status == 0)
	{
		//成功处理
		alert("处理成功!");
		if (retpar != null)
		{
			alert(retpar[0]);
		}
	}
	else
	{
		alert(msg);
	}
}


/*以下为身份认证接口函数*/
//检查是否插入key
function ESACheckIsKey(func,param,ishttps)
{
	var input = new Array();
	input[0] = "";
	esaLinkServer(113,0,input,func,param,ishttps);
}
//检查Key口令
function ESAVerifyPin(func,param,ishttps)
{
	var input = new Array();
	input[0] = "";
	esaLinkServer(113,1,input,func,param,ishttps);
}
//写入用户文件数据
function ESAWriteFile(filedata,func,param,ishttps)
{
	var input = new Array();
	input[0] = filedata.toString();;
	esaLinkServer(113,2,input,func,param,ishttps);
}
//读取用户文件数据
function ESAReadFile(func,param,ishttps)
{
	var input = new Array();
	input[0] = "";
	esaLinkServer(113,3,input,func,param,ishttps);
}
//删除用户文件数据
function ESADeleteFile(func,param,ishttps)
{
	var input = new Array();
	input[0] = "";
	esaLinkServer(113,4,input,func,param,ishttps);
}
//获取证书绑定的用户名
function ESAGetUserName(func,param,ishttps)
{
	var input = new Array();
	input[0] = "";
	esaLinkServer(113,5,input,func,param,ishttps);
}
//验证用户
function ESAVerifyUser(username,func,param,ishttps)
{
	var input = new Array();
	input[0] = username.toString();;
	esaLinkServer(113,6,input,func,param,ishttps);
}

/*以下为网页签章接口函数*/
//网页签章
function WebStartSign(sealType,SignData,filename,sealcode,func,param,ishttps)
{
	var input=new Array();
	input[0]=sealType.toString();
	input[1]=SignData.toString();
	input[2]=filename.toString();
	input[3]=sealcode.toString();
	esaLinkServer(101,12,input,func,param,ishttps);
}
//获取网页签章中的属性
function WebGetAttr(xmldata,attr,func,param,ishttps)
{
	var input=new Array();
	input[0]=xmldata.toString();
	input[1]=attr.toString();
	esaLinkServer(101,13,input,func,param,ishttps);
}
//验证网页签章是否有效
function WebVerify(xmldata,verifyData,func,param,ishttps)
{
	var input=new Array();
	input[0]=xmldata.toString();
	input[1]=verifyData.toString();
	esaLinkServer(101,14,input,func,param,ishttps);
}
//显示证书
function WebShowCert(xmldata,state,func,param,ishttps)
{
	var input=new Array();
	input[0]=xmldata.toString();
	input[1]=state.toString();
	esaLinkServer(101,15,input,func,param,ishttps);
}

/*PDF后台云签名接口-只能单个签*/
//云签中间件地址,签章类型,是否缓存印章,指令参数,回调函数,业务系统输入参数(回调会传递回来),是否为HTTPS协议
function PDFSignCloud(Servlet,SealType,Reserved,SignKeyWord,func,param,ishttps)
{
	var input=new Array();
	input[0]=Servlet.toString();
	input[1]=SealType.toString();
	input[2]=Reserved.toString();
	input[3]=SignKeyWord.toString();
	esaLinkServer(101,3,input,func,param,ishttps);
}

/*PDF后台云签名接口-支持多文件名称*/
//云签中间件地址,签章类型,是否缓存印章,指令参数,回调函数,业务系统输入参数(回调会传递回来),是否为HTTPS协议
export function PDFSignCloudThread(Servlet,SealType,Reserved,SignKeyWord,func,param,ishttps)
{
	var input=new Array();
	input[0]=Servlet.toString();
	input[1]=SealType.toString();
	input[2]=Reserved.toString();
	input[3]=SignKeyWord.toString();
	esaLinkServer(101,17,input,func,param,ishttps);
}


//清除缓存印章数据
//回调函数,业务系统输入参数(回调会传递回来),是否为HTTPS协议
function PDFSignFreeCloud(func,param,ishttps)
{
	esaLinkServer(101,4,"",func,param,ishttps);
}

//使用本地XML文件进行单个PDF会签
function PDFSignByImg(Servlet,SealType,Reserved,SignKeyWord,filePath,func,param,ishttps)
{
	var input=new Array();
	input[0]=Servlet.toString();
	input[1]=SealType.toString();
	input[2]=Reserved.toString();
	input[3]=SignKeyWord.toString();
	input[4]=filePath.toString();
	esaLinkServer(101,7,input,func,param,ishttps);
}

//使用本地XML文件进行多个PDF会签
function PDFSignByImgThread(Servlet,SealType,Reserved,SignKeyWord,filePath,func,param,ishttps)
{
	var input=new Array();
	input[0]=Servlet.toString();
	input[1]=SealType.toString();
	input[2]=Reserved.toString();
	input[3]=SignKeyWord.toString();
	input[4]=filePath.toString();
	esaLinkServer(101,18,input,func,param,ishttps);
}

//后台删除PDF文档印章，与PDFSignByImg盖章匹配
function PDFRevokedSign(Servlet,Filepath,Fieldid,func,param,ishttps)
{
	var input=new Array();
	input[0]=Servlet.toString();
	input[1]=Filepath.toString();
	input[2]=Fieldid.toString();
	esaLinkServer(101,8,input,func,param,ishttps);
}

//后台PDF签章设置系统授权码和日志ID
function PDFSetReg(Appcode,NoteId,func,param,ishttps)
{
	var input=new Array();
	input[0]=Appcode.toString();
	input[1]=NoteId.toString();
	esaLinkServer(101,11,input,func,param,ishttps);
}

//PDF云打印(通过在线控件打印文件)
function PDFPrintCloud(lpFile,lpRang,lpcopies,func,param,ishttps)
{
	var input=new Array();
	input[0]=lpFile.toString();
	input[1]=lpRang.toString();
	input[2]=lpcopies.toString();
	esaLinkServer(101,16,input,func,param,ishttps);
}

/* 以下为其他签章接口 */
//获取印章个数
function BaseGetSealCount(SealType,func,param,ishttps)
{
	var input=new Array();
	input[0]=SealType.toString();
	esaLinkServer(101,10,input,func,param,ishttps);
}

//获取印模图片及印模尺寸
function BaseGetSeal(sealType,func,param,ishttps)
{
	var input=new Array();
	input[0]=sealType.toString();
	esaLinkServer(101,0,input,func,param,ishttps);
}

//对数据签名（固定哈希算法SHA1）
function BaseSignFixed(hashdata,func,param,ishttps)
{
	var input=new Array();
	input[0]=hashdata.toString();
	esaLinkServer(101,1,input,func,param,ishttps);
}

//对数据签名(外部传入Hash算法及数据)
//hashType 1MD5 2SHA1 3SHA256 4SM3
function BaseSignByHash(hashdata,hashType,func,param,ishttps)
{
	var input=new Array();
	input[0]=hashdata.toString();
	input[1]=hashType.toString();
	esaLinkServer(101,2,input,func,param,ishttps);
}

//获取证书
//CertType 1签名 2加密
function BaseGetCert(CertType,func,param,ishttps)
{
	var input=new Array();
	input[0]=CertType.toString();
	esaLinkServer(101,5,input,func,param,ishttps);
}

//对本地文件(数据)进行签名
function BaseSignByFile(filepath,func,param,ishttps)
{
	var input=new Array();
	input[0]=filepath.toString();
	esaLinkServer(101,6,input,func,param,ishttps);
}

//对授权码，日志码，印章特性码设置
function BaseSetRegEx(appcode,notecode,sealcode,func,param,ishttps)
{
	var input=new Array();
	input[0]=appcode.toString();
	input[1]=notecode.toString();
	input[2]=sealcode.toString();
	esaLinkServer(114,0,input,func,param,ishttps);
}

//对服务进行配置
function BaseSetSer(seraddr,servlet,proxy,func,param,ishttps)
{
	var input=new Array();
	input[0]=seraddr.toString();
	input[1]=servlet.toString();
	input[2]=proxy.toString();
	esaLinkServer(114,1,input,func,param,ishttps);
}

/*以下为CA发证接口*/
//返回当前插入key的csp或者dll名称
function CAEnumName(type,func,param,ishttps)
{
	var input= new Array();
	input[0] = type.toString();
	esaLinkServer(111,1,input,func,param,ishttps);
}

//删除KEY里面所有证书
function CADelCont(cspname,type,func,param,ishttps)
{
	var input= new Array();
	input[0] = cspname.toString();
	input[1] = type.toString();
	esaLinkServer(111,2,input,func,param,ishttps);
}

//产生p1010:18
function CACreateP10(xml,func,param,ishttps)
{
	var input= new Array();
	input[0] = xml.toString();
	esaLinkServer(111,3,input,func,param,ishttps);
}

//安装证书
function CAInstallCer(cspname,contname,Cer,pfx,pfxpass,keyType,func,param,ishttps)
{
	var input= new Array();
	input[0] = cspname.toString();
	input[1] = contname.toString();
	input[2] = Cer.toString();
	input[3] = pfx.toString();
	input[4] = pfxpass.toString();
	input[5] = keyType.toString();
	esaLinkServer(111,4,input,func,param,ishttps);
}

//获取Key中证书
function CAGetCert(cspname,bSign,keyType,func,param,ishttps)
{
	var input = new Array();
	input[0] = cspname.toString();
	input[1] = bSign.toString();
	input[2] = keyType.toString();
	esaLinkServer(111,5,input,func,param,ishttps);
}



//////////////////
// WEBPACK FOOTER
// ./static/CloudSign/js/esaclient.js
// module id = piMj
// module chunks = 159